export const state = {
	currentLocation: '/dashboard',
};
